/* eslint-disable no-alert */
import React, { useState } from 'react';
import { CheckboxGroup } from '@uhg-abyss/web/ui/CheckboxGroup';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';

export const CheckboxGroupQtn = (props) => {
  const [question] = useState(props);

  question?.qstn?.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });

  const deselectEnableValues: string[] = [];
  question?.qstn?.options.forEach((optn) => {
    if (optn.values[0].deselectEnabled === true)
      deselectEnableValues.push(optn.values[0].id);
  });

  const updateCheckBox = (event: string[]) => {
    let modifiedValues: string[] = [];
    if (
      event.length > 0 &&
      deselectEnableValues.indexOf(event[event.length - 1]) !== -1
    ) {
      modifiedValues.push(event[event.length - 1]);
    } else if (event.length > 0 && deselectEnableValues.includes(event[0])) {
      modifiedValues = event.slice(1, event.length);
    } else {
      modifiedValues = event;
    }
    question.form.setValue(`qstn-${question.qstn.questionId}`, modifiedValues);
    question.qstn.selectedValues = modifiedValues;
  };

  return (
    <CheckboxGroup
      label={<strong>{`${question.serial}. ${question.qstn?.questionText}`}</strong>}
      model={`qstn-${question?.qstn?.questionId}`}
      key={`chck-${question?.qstn?.questionId}`}
      validators={{ required: 'Please select at least one option' }}
      onChange={(e) => {
        updateCheckBox(e);
      }}
    >
      <CheckboxGroup.Column>
        {question?.qstn?.options.map((_mp, idx) => {
          return (
            <Checkbox
              label={_mp.values[0].value}
              value={_mp.values[0].id}
              key={_mp.id}
            />
          );
        })}
      </CheckboxGroup.Column>
    </CheckboxGroup>
  );
};
